import { css } from '@emotion/css';
import globalStyle from 'constants/global.style';
import { colors } from 'constants/theme';
import { LotteryTicket } from 'models/lotteryModel';
const bgTitleLinear = `${colors.lottery}`;

interface Props {
    ticketList: LotteryTicket[];
    onRemoveTicket: (tickets: LotteryTicket[]) => void;
}
function LotteryTicketsTable(props: Props) {
    const { ticketList, onRemoveTicket } = props;
    const formatCodeString = (codes: string) => {
        if (codes) {
            return codes.replace(/&/g, ',');
        }
        return '';
    };

    const removeTicket = (idx: number) => {
        const newTicketList = ticketList.filter((_, index) => index !== idx);
        onRemoveTicket(newTicketList);
    };

    const removeAllTicket = () => {
        if (ticketList.length === 0) {
            return;
        }
        onRemoveTicket([]);
    };
    return (
        <section className={styles.wrap}>
            <div className={styles.heading}>
                <h4>
                    Nội Dung Cược
                    {ticketList.length > 0 && <span className={styles.ticketLabel}>{ticketList.length} vé</span>}
                </h4>
                <button type="button" className={styles.btnClearAll} onClick={removeAllTicket}>
                    Xoá Tất Cả
                </button>
            </div>
            <div className={styles.table}>
                <div className={styles.row}>
                    <div className={`${styles.col} ${styles.title}`}>Tên cược</div>
                    <div className={`${styles.col} ${styles.title}`} style={{ flex: '0 0 200px' }}>
                        Số cược
                    </div>
                    <div className={`${styles.col} ${styles.title}`} style={{ flex: '0 0 100px' }}>Tổng cược</div>
                    <div className={`${styles.col} ${styles.title}`} style={{ flex: '0 0 100px' }}>Cấp số nhân</div>
                    <div className={`${styles.col} ${styles.title}`}>Tiền cược</div>
                    <div className={`${styles.col} ${styles.title}`} style={{ flex: '0 0 150px' }}>Tiền thắng/1 lần</div>
                    <div className={`${styles.col} ${styles.title}`}>Tỉ lệ</div>
                    <div className={`${styles.col} ${styles.title}`} style={{ flex: '0 0 50px' }}></div>
                </div>
                {ticketList.length > 0 ? (
                    ticketList.map((item, index) => (
                        <div className={styles.row} key={index}>
                            <p className={`${styles.col} ${globalStyle.text.blue}`} style={{ fontWeight: '600' }}>
                                {item.trTitle} - {item.stTitle}
                            </p>
                            <p className={`${styles.col} ${styles.codesBet}`} style={{ flex: '0 0 200px' }}>
                                {formatCodeString(item.codes)}
                            </p>
                            <p className={styles.col} style={{ flex: '0 0 100px' }}>{item.total}</p>
                            <p className={styles.col} style={{ flex: '0 0 100px' }}>{item.times}</p>
                            <p className={`${styles.col} ${globalStyle.text.blue}`}>
                                {new Intl.NumberFormat().format(item.money * item.times)}
                            </p>
                            <p className={styles.col} style={{ flex: '0 0 150px' }}>{new Intl.NumberFormat().format(Number(item.dyprize.prize) * item.times * 1000)}</p>
                            <p className={styles.col}>{item.dyprize.prize}</p>
                            <div className={styles.col} style={{ flex: '0 0 50px' }}>
                                <button type="button" className={styles.btnRemoveTicket} onClick={() => removeTicket(index)}>
                                    <img src={require('assets/images/icons/close-lt.png')} alt="" />
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className={styles.noData}>
                        {/* <img src={require('assets/images/icons/no-data.png')} alt="" /> */}
                        <p>Chưa có vé cược</p>
                    </div>
                )}
            </div>
        </section>
    );
}

const styles = {
    wrap: css`
        padding-top: 16px;
    `,
    heading: css`
        background: ${bgTitleLinear};
        color: ${colors.white};
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px 16px;
        border-radius: 8px;
        margin-bottom: 16px;
    `,
    ticketLabel: css`
        background: ${colors.red};
        border-radius: 40px;
        font-size: 14px;
        padding: 4px 8px;
        display: inline-block;
        margin-left: 6px;
    `,
    btnClearAll: css`
        border: 1px solid ${colors.lightBlue};
        border-radius: 8px;
        padding: 6px;
        font-size: 14px;
        color: ${colors.white};
    `,
    table: css`
        border: 1px solid ${colors.lightBlue};
        border-radius: 8px;
        overflow: hidden;
        min-height: 150px;
        &.table-col-center {
            .col {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    `,
    codesBet: css`
        word-wrap: break-word;
        max-width: 200px;
    `,
    row: css`
        display: flex;
        border-bottom: 1px solid ${colors.lightBlue};
        &:first-child {
            border-bottom-color: ${colors.lightBlue};
        }
        &:last-child {
            border-bottom: none;
        }
        &:hover {
            background: #f0f7ff;
        }
    `,
    col: css`
        flex: 1;
        padding: 12px 8px;
        text-align: center;
        font-size: 14px;
    `,
    title: css`
        font-weight: 900;
        background: #f0f7ff;
        font-size: 15px !important;
    `,
    noData: css`
        text-align: center;
        padding: 30px;
        p {
            margin-top: 8px;
            font-size: 14px;
        }
    `,
    btnRemoveTicket: css`
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        img {
            height: 16px;
        }
    `,
};

export default LotteryTicketsTable;
